<script setup>
import {computed, ref} from "vue";
import trackersCompaniesService from "@/services/trackers-companies.service";
import CustomFieldValue from "@/components/customFields/CustomFieldValue.vue";

const showModal = ref(false);
const answers = ref([]);
const submittedBy = ref(null);

const title = computed(() => {
    let value = 'Submitted answers';

    if (submittedBy.value) {
        value += ` by ${submittedBy.value}`;
    }

    return value;
});

async function getData(trackerId, startupId) {
    const {data} = await trackersCompaniesService.getApplicationData(trackerId, startupId);

    answers.value = data.answers;
    submittedBy.value = data.submitted_by;
}

function open(trackerId, startupId) {
    showModal.value = true;
    getData(trackerId, startupId);
}

defineExpose({
    open
});
</script>

<template>
    <b-modal v-model="showModal" :title="title" hide-footer modal-class="modal-w-md">
        <div v-for="(answer, index) in answers" :key="index" class="mt-2 mb-4">
            <h5 class="heading5 heading5--secondary">{{answer.field.name}}</h5>

            <CustomFieldValue
                :field="answer.field"
                :init-value="answer.value"
                :editable="false"
            />
        </div>
    </b-modal>
</template>

<style scoped>

</style>
